<template>
  <div class="commonDialogBody">
           <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
  <el-form-item :label="formLabelAlign.obj.feeCode">
    <el-input v-model="formLabelAlign.feeCode" size="small"></el-input>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.feeName">
    <el-input v-model="formLabelAlign.feeName" size="small"></el-input>
  </el-form-item>
  <el-form-item :label="formLabelAlign.obj.feeCategory" >
    <el-select  clearable v-model="PayItemval" placeholder="请选择"  size="small" @change="TenementType" >
        <el-option v-for="item in PayItem" :key="item.PayItemval" :label="item.PayItemlab" :value="item.PayItemval"></el-option>
    </el-select>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.displayName" >
     <el-input v-model="formLabelAlign.displayName" size="small"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.taxRateName" >
       <el-cascader
    :options="amount"
    v-model="amountval"
    :props="{ checkStrictly: true }"
    :show-all-levels="false"
    @change="AmountChange"
    clearable></el-cascader>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.subjectsName" >
      <el-cascader
       v-model="financeval"
    :options="finance"
    @change="FinanceChange"
    :props="{ checkStrictly: true }"
    :show-all-levels="false"
    clearable></el-cascader>
  </el-form-item>
      <el-form-item :label="formLabelAlign.obj.maintenanceCost" >
     <el-input v-model="formLabelAlign.maintenanceCost" size="small"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.remarks" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "ChargeItemDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
      amount:[],
      amountval:"",
      finance:[],
      financeval:"",
    options:[],
     value: [],
     PayItem: [],
    PayItemval: '',
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
    taxRatelab:"",
    taxRateval:"",
    subjectslab:"",
    subjectsval:"",

    };
  },
  methods: {
    AmountChange(){
      // console.log(this.amountval)
      var arr = this.amountval
      var ende = arr[arr.length-1]
      // console.log(ende);
      for(let val of this.amount){
        if(this.amountval == val.value){
          // console.log(val)
          this.taxRateval = val.value
          this.taxRatelab = val.label
        }else{
          var end = arr[0]
          // console.log(end);
          if(end == val.value){
            // console.log(val)
            for(let arr of val.children){
              if(ende == arr.value){
                // console.log(arr)
                  this.taxRateval = arr.value
                  this.taxRatelab = arr.label
              }
            }
          }
        }

      }
    },
    FinanceChange(){
      // console.log(this.financeval)
      var arr = this.financeval
      var ende = arr[arr.length-1]
      // console.log(ende);
      for(let val of this.amount){
        if(this.financeval == val.value){
          this.subjectsval = val.value
          this.subjectslab = val.label
        }else{
          var end = arr[0]
          // console.log(end);
          if(end == val.value){
            // console.log(val)
            for(let arr of val.children){
              if(ende == arr.value){
                // console.log(arr)
                  this.subjectsval = val.value
                  this.subjectslab = val.label
              }
            }
          }
        }

      }
    },
      handleChange(value){
          //  console.log(value);
      },
      TenementType(PayItemval){
          // console.log(PayItemval)
          this.PayItemval = PayItemval
      },
    modification(){
        if(this.title == "修改"){
            let obj = {
               "feeCode":this.formLabelAlign.feeCode,
               "feeName":this.formLabelAlign.feeName,
               "feeCategory":this.PayItemval,
                "subjectsCode":this.financeval,
               "subjectsName":this.subjectslab,
               "displayName":this.formLabelAlign.displayName,
               "maintenanceCost":this.formLabelAlign.maintenanceCost,
               "taxRateCode":this.amountval,
               "taxRateName": this.taxRatelab,
               "id":this.formLabelAlign.id,
               "remarks":this.formLabelAlign.remarks,
            }
            if(obj.feeCode == undefined || obj.feeCode == ""){
               this.$message({
                        type: "warning",
                        message: "请填写项目代码"
                    })
            }else if(obj.feeName == undefined || obj.feeName == ""){
            this.$message({
                        type: "warning",
                        message: "请填写项目名称"
                    })
            }else if(obj.feeCategory == undefined || obj.feeCategory == ""){
                  this.$message({
                        type: "warning",
                        message: "请选择收费项目类别"
                    })
            }else if(obj.maintenanceCost == undefined || obj.maintenanceCost == ""){
                  this.$message({
                        type: "warning",
                        message: "请填写商品编码"
                    })
            }else if(obj.subjectsCode == undefined || obj.subjectsCode == ""){
                console.log(1)
            }else if(obj.subjectsName == undefined || obj.subjectsName == ""){
 console.log(1)
            }else if(obj.displayName == undefined || obj.displayName == ""){
                this.$message({
                        type: "warning",
                        message: "请填写显示名称"
                })
            }else if(obj.taxRateCode == undefined || obj.taxRateCode == ""){
 console.log(1)
            }else if(obj.taxRateName == undefined || obj.taxRateName == ""){
               console.log(1)
            }else{
              this.$http.post(this.$requestUrl.POST_ITEM_ADD,obj).then((res) => {
                let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                   this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            }
        }else{
            // console.log("添加")
            let obj = {
               "feeCode":this.formLabelAlign.feeCode,
               "feeName":this.formLabelAlign.feeName,
               "feeCategory":this.PayItemval,
               "subjectsCode":this.subjectsval,
               "subjectsName":this.subjectslab,
               "displayName":this.formLabelAlign.displayName,
               "maintenanceCost":this.formLabelAlign.maintenanceCost,
               "taxRateCode":this.taxRateval,
               "taxRateName": this.taxRatelab,
               "remarks":this.formLabelAlign.remarks,
            }
                      if(obj.feeCode == undefined || obj.feeCode == ""){
               this.$message({
                        type: "warning",
                        message: "请填写项目代码"
                    })
            }else if(obj.feeName == undefined || obj.feeName == ""){
            this.$message({
                        type: "warning",
                        message: "请填写项目名称"
                    })
            }else if(obj.feeCategory == undefined || obj.feeCategory == ""){
                  this.$message({
                        type: "warning",
                        message: "请选择收费项目类别"
                    })
            }else if(obj.maintenanceCost == undefined || obj.maintenanceCost == ""){
                  this.$message({
                        type: "warning",
                        message: "请填写商品编码"
                    })
            }else if(obj.subjectsCode == undefined || obj.subjectsCode == ""){
               
            }else if(obj.subjectsName == undefined || obj.subjectsName == ""){

            }else if(obj.displayName == undefined || obj.displayName == ""){
                this.$message({
                        type: "warning",
                        message: "请填写显示名称"
                    })
            }else if(obj.taxRateCode == undefined || obj.taxRateCode == ""){

            }else if(obj.taxRateName == undefined || obj.taxRateName == ""){
              
            }else{
                this.$http.post(this.$requestUrl.POST_ITEM_ADD,obj).then((res) => {
              let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                   this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
            }

        }

    },
    getMsgFormSon(data){
        // console.log(data)
        this.options = data
    },
    handleClose(done) {
     this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      if(this.formLabelAlign.obj == undefined){
   let obj = {
            "feeCode":"项目代码",
            "feeName":"项目名称",
            "feeCategory":"收费项目类别",
            "displayName":"显示名称",
            "taxRateName":"税额对应科目",
            "subjectsName":"财务对应科目",
            "maintenanceCost":"商品编码",
            "remarks":"备注信息"
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>